// extracted by mini-css-extract-plugin
export default {"text":"LinkButton_text__cZuZe"};